angular.module('zc.projects')

.directive 'zcCampaignInterestWidgetEvent', ($q, CampaignStats, Devise, SearchFilter) ->
  campaign_event_statstrict: 'E'
  scope: {
    campaign: '='
    filters: '='
  }
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_interest_widget_event.html'

  link: (scope, element, attrs) ->
    scope.filters = SearchFilter.resolveFromLocation()
    SearchFilter.setComponentDefaults 'campaignEventsList',
      sort_prop:
        default: 'predefined'
      sort_direction:
        default: 'desc'

    scope.$on '$destroy', () ->
      SearchFilter.removeComponentDefaults('campaignEventsList')

    scope.setSortProp = (key) ->
      if scope.filters.sort_prop == key
        if scope.filters.sort_direction == 'desc'
          scope.filters.sort_direction = 'asc'
        else
          scope.filters.sort_direction = 'desc'
      else
        scope.filters.sort_prop = key
        scope.filters.sort_direction = 'desc'
      scope.updateData()

    scope.updateData = ->
      CampaignStats.getCampaignEventStats
        apikey: scope.campaign.apikey
        campaign_id: scope.campaign.id
        element_id: scope.campaign.element.id
        dimension: 'hourly'
        start_at: scope.filters.start_at
        end_at: moment(scope.filters.end_at).endOf('day').valueOf()
      .then (campaign_event_stats) ->
        campaign_event_stat_by_id = {}
        scope.campaign_events = []
        scope.iw_started_count = scope.iw_started_conversion_count = 0
        for stat in campaign_event_stats
          stat.name = stat._id
          stat.conversion_rate = if stat.count > 0 then 100 * stat.conversion_count  / stat.count else 0
          if stat.name is 'iw_started'
            scope.iw_started_count = stat.count
            scope.iw_started_conversion_count = stat.conversion_count
          scope.campaign_events.push stat
        if scope.filters.sort_prop isnt 'predefined'
          scope.campaign_events = _.sortBy(scope.campaign_events, scope.filters.sort_prop)
          if scope.filters.sort_direction == 'desc'
            scope.campaign_events.reverse()

    scope.$watch 'filters', scope.updateData, true



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_interest_widget_event.directive.coffee